import { render, staticRenderFns } from "./CalendarPane.vue?vue&type=template&id=2d537c60&scoped=true&"
import script from "./CalendarPane.vue?vue&type=script&lang=ts&"
export * from "./CalendarPane.vue?vue&type=script&lang=ts&"
import style0 from "./CalendarPane.vue?vue&type=style&index=0&id=2d537c60&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d537c60",
  null
  
)

export default component.exports